/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { OrganizationStrictHttpResponse } from '../../organization-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { StringStringKeyValuePair } from '../../models/string-string-key-value-pair';

export interface AdminParentOrganizationsGet$Params {
}

export function adminParentOrganizationsGet(http: HttpClient, rootUrl: string, params?: AdminParentOrganizationsGet$Params, context?: HttpContext): Observable<OrganizationStrictHttpResponse<Array<StringStringKeyValuePair>>> {
  const rb = new RequestBuilder(rootUrl, adminParentOrganizationsGet.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as OrganizationStrictHttpResponse<Array<StringStringKeyValuePair>>;
    })
  );
}

adminParentOrganizationsGet.PATH = '/Admin/ParentOrganizations';
